"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunkedUploadSessionToJSON = exports.ChunkedUploadSessionFromJSONTyped = exports.ChunkedUploadSessionFromJSON = exports.instanceOfChunkedUploadSession = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ChunkedUploadSession interface.
 */
function instanceOfChunkedUploadSession(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfChunkedUploadSession = instanceOfChunkedUploadSession;
function ChunkedUploadSessionFromJSON(json) {
    return ChunkedUploadSessionFromJSONTyped(json, false);
}
exports.ChunkedUploadSessionFromJSON = ChunkedUploadSessionFromJSON;
function ChunkedUploadSessionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadSessionId': !(0, runtime_1.exists)(json, 'upload_session_id') ? undefined : json['upload_session_id'],
        'maxChunkSizeMb': !(0, runtime_1.exists)(json, 'max_chunk_size_mb') ? undefined : json['max_chunk_size_mb'],
    };
}
exports.ChunkedUploadSessionFromJSONTyped = ChunkedUploadSessionFromJSONTyped;
function ChunkedUploadSessionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'upload_session_id': value.uploadSessionId,
        'max_chunk_size_mb': value.maxChunkSizeMb,
    };
}
exports.ChunkedUploadSessionToJSON = ChunkedUploadSessionToJSON;
